



// import React, { Component } from "react";
// import { Button, Form } from "react-bootstrap";
// import configData from "../config.json";
// import { toast } from "react-toastify";
// import "./Abha.css";
// export default class AbhaAddressChange extends Component {
//   constructor(props) {
//     super(props);
//      this.state = {
//       requestId: sessionStorage.getItem("requestId"),
//       abhaAddress: sessionStorage.getItem("abhaaddress"),
//       isValid: null,
//       isAvailable: null,
//       suggestions: [],
//       isSubmitting: false,
//     };
//   }

//   showToast = (msg, type) => {
//     switch (type) {
//       case "success":
//         toast.success(msg);
//         break;
//       case "error":
//         toast.error(msg);
//         break;
//       case "warning":
//         toast.warn(msg);
//         break;
//       default:
//         toast.info(msg);
//     }
//   };
//   componentDidMount() {
//     this.ResponseHandler();
//     this.Handleabhachange();
  
// }
//   ResponseHandler = () => {
//     var formData = new FormData();

//     formData.append("requestId", this.state.requestId);
//     fetch(configData.api_url + "C_Abhadetails/retriverequestId", {
//       method: "POST",
//       mode: "cors",
//       body: formData,
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         if (data.status === "success" && data.detail && data.detail.abhaprofile) {
//           const abhaDetails = JSON.parse(data.detail.abhaprofile);
//           const abhaProfile = abhaDetails.ABHAProfile;
//           if (abhaProfile)
//             this.setState({
//               AbhaProfile: abhaProfile,
//             });
//         } else {
//            this.showToast(data.message||"Invalid Transaction Id")}

//       });
//   };
//   Handleabhachange = (e) => {
//     const { requestId } = this.state;

//     const formData = new FormData();
//     formData.append("abhaAddress", sessionStorage.abhaAddress);
//     formData.append("requestId", requestId);

//     fetch(configData.api_url + "C_Abhadetails/getSuggetionsByabhaAddress", {
//       method: "POST",
//       mode: "cors",
//       body: formData,
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.status === "success" && data?.isAvailable) {
//           toast.success("ABHA address is available");
//           this.setState({ isAvailable: true, suggestions: [] });
//         } else {
        
//           this.setState({
//             isAvailable: false,
//             suggestions: data.abhaDetails?.abhaAddressList || [],
//           });
//         }
//       })
//       .catch(() => toast.error("Error checking ABHA address availability"));
//   };
//   validateAbhaAddress = (input) => {
//     const minLength = 6;
//     const maxLength = 18;
//     const regex = /^[a-zA-Z0-9._]+$/;
  
//     if (
//       input.length < minLength ||
//       input.length > maxLength ||
//       !regex.test(input)
//     ) {
//       return false;
//     }
  
//     if (/^[._]|[._]$/.test(input)) {
//       return false; // can't start or end with . or _
//     }
  
//     const dotCount = (input.match(/\./g) || []).length;
//     const underscoreCount = (input.match(/_/g) || []).length;
  
//     if (dotCount > 1 || underscoreCount > 1) {
//       return false;
//     }
  
//     return true;
//   };
  
//   handleAbhaBlur = () => {
//     // Skip validation if we are currently submitting
//     if (this.state.isSubmitting) return;
  
//     const { isValid, requestId, abhaAddress } = this.state;
//     if (!isValid) {
//       this.showToast("Invalid ABHA Address format. Please follow the rules.", "error");
//       return;
//     }
  
//     const formData = new FormData();
//     formData.append("abhaAddress", abhaAddress);
//     formData.append("requestId", requestId);
  
//     fetch(configData.api_url + "C_Abhadetails/getSuggetionsByabhaAddress", {
//       method: "POST",
//       mode: "cors",
//       body: formData,
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.status === "success" && data?.isAvailable) {
//           toast.success("ABHA address is available");
//           this.setState({ isAvailable: true, suggestions: [] });
//         } else {
//           toast.error("ABHA address is already taken");
//           this.setState({
//             isAvailable: false,
//             suggestions: data.abhaDetails?.abhaAddressList || [],
//           });
//         }
//       })
//       .catch(() => toast.error("Error checking ABHA address availability"));
//   };
  

//   handleSuggestionClick = (suggestion) => {
//     const isValid = this.validateAbhaAddress(suggestion);
//     this.setState({
//       abhaAddress: suggestion,
//       isValid,
//       isAvailable: null,
//       suggestions: [],
//       abhaDetails: {},
//     });
//   };

//   handleSubmit = (e) => {
//     e.preventDefault();
//     const formData = new FormData();
//     const { abhaAddress } = this.state;
//     this.setState({ isSubmitting: true });
  
//     formData.append("abhaAddress", abhaAddress);
//     formData.append("requestId", this.state.requestId);
   

//     fetch(configData.api_url + "C_Abhadetails/setnewabhaAddress", {
//       method: "POST",
//       mode: "cors",
//       body: formData,
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         toast[data.status === "success" ? "success" : "error"](data.message);
//         this.setState({ isSubmitting: false });
      
//       })
   
      
//   };
//   handlenextClick = () => {
//     const formData = new FormData();
//     formData.append("requestId", this.state.requestId);
//     fetch(configData.api_url + "C_Abhadetails/getAbhaProfile", {
//       method: "POST",
//       mode: "cors",
//       body: formData,
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         sessionStorage.setItem(
//           "abhaAddress",
//           this.state.phrAddress
//         );

//         this.showToast(data.message);

//         if (data.status === "success") {
//           sessionStorage.setItem("abhaProfileStatus", "success");
//           window.location.href = "/abhaprofile";
//         }
//       });
//   };
//   handleAbhaChange = (e) => {
//     const abhaAddress = e.target.value.trim();
//     const isValid = this.validateAbhaAddress(abhaAddress);
//     this.setState({ abhaAddress, isValid, isAvailable: null, suggestions: [] });
//   };
  
//   render() {
//     const { isValid, abhaAddress, suggestions } = this.state;
//     return (
//       <div>
//         <div className="row justify-content-md-center text-center abhaAddressChange">
//         <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>
//           ABHA Address Update / Creation
//         </h3>
//           <div className="col-md-6">
//             <div className="widget_BG widget_BG_grid mb-2">
//               <Form.Group>
//                 <Form.Label>ABHA Address Creation</Form.Label>
//                 <div className="d-flex gap-2">
//                   <Form.Control
//                     type="text"
//                     value={abhaAddress}
//                     onChange={this.handleAbhaChange}
//                     onBlur={this.handleAbhaBlur}
//                     onKeyDown={this.onKeyDown}
//                     className={`form-control ${
//                       abhaAddress ? (isValid ? "is-valid" : "is-invalid") : ""
//                     }`}
//                   />
                  
//                 </div>
//                 <Form>
//                   <p>
//                     Current ABHA Address:
//                     <strong style={{wordBreak: "break-word"}}> {sessionStorage.abhaAddress}</strong>
//                           </p>
//                             {abhaAddress && !isValid && (
//                             <div className="text-danger mt-1" style={{ fontSize: "0.9rem", textAlign: "left" }}>
//                               ABHA Address Rules:
//                               <ul className="m-0 ps-3">
//                                 <li>Length must be between 6 to 18 characters</li>
//                                 <li>Only letters, numbers, dots (.) and underscores (_) allowed</li>
//                                 <li>Cannot start or end with dot or underscore</li>
//                                 <li>At most 1 dot and 1 underscore allowed</li>
//                               </ul>
//                             </div>
//                           )}
//                         </Form>
       
//                   <div className="mt-2">
//                     <div className="d-flex flex-wrap mt-1">
//                       {suggestions.length > 0 && (
//                         <div className="mt-2">
//                           <strong>Suggestions:</strong>
//                           <div className="d-flex flex-wrap mt-1">
//                             {suggestions.map((s, i) => (
//                               <span
//                                 key={i}
//                                 className="badge bg-secondary me-2 mb-2"
//                                 onClick={() => this.handleSuggestionClick(s)}
//                                 style={{ cursor: "pointer" }}
//                               >
//                                 {s}
//                               </span>
//                             ))}
//                           </div>
//                         </div>
//                       )}
//                     </div>
//                   </div>
             
//               </Form.Group>
//               <Button className="rounded-0 m-1" onClick={this.handleSubmit}>
//                 New ABHA Address
//               </Button>
//             </div>
//           </div>
//         </div>
//         <div className="row  widget_BG widget_BG_grid m-0 mt-2">
//           <div className="col text-end">
//             <Button className="rounded-0 m-1" onClick={this.handlenextClick}>
//               Next
//             </Button>
//           </div>
//         </div>
//       </div>
//     );
//   }
// }
import React, { Component } from "react";
import { Button, Form } from "react-bootstrap";
import configData from "../config.json";
import { toast } from "react-toastify";
import "./Abha.css";

export default class AbhaAddressChange extends Component {
  constructor(props) {
    super(props);
    this.state = {
      requestId: sessionStorage.getItem("requestId"),
      abhaAddress: sessionStorage.getItem("abhaaddress"),
      isValid: null,
      isAvailable: null,
      suggestions: [],
      isSubmitting: false,
      isChecking: false, // NEW: Track availability checking state
    };
    this.checkAvailabilityTimeout = null; // For debounced checking
  }
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.success(msg);
    }
  };

  componentDidMount() {
    this.ResponseHandler();
    this.Handleabhachange();
  }

  componentWillUnmount() {
    // Clear timeout when component unmounts
    if (this.checkAvailabilityTimeout) {
      clearTimeout(this.checkAvailabilityTimeout);
    }
  }

  ResponseHandler = () => {
    var formData = new FormData();
    formData.append("requestId", this.state.requestId);
    fetch(configData.api_url + "C_Abhadetails/retriverequestId", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success" && data.detail && data.detail.abhaprofile) {
          const abhaDetails = JSON.parse(data.detail.abhaprofile);
          const abhaProfile = abhaDetails.ABHAProfile;
          if (abhaProfile)
            this.setState({
              AbhaProfile: abhaProfile,
            });
        } else {
          this.showToast(data.message || "Invalid Transaction Id", "error");
        }
      })
      .catch((error) => {
        this.showToast("Error retrieving request details", "error");
      });
  };

  Handleabhachange = (e) => {
    const { requestId } = this.state;
    const formData = new FormData();
    formData.append("abhaAddress", sessionStorage.abhaAddress);
    formData.append("requestId", requestId);

    fetch(configData.api_url + "C_Abhadetails/getSuggetionsByabhaAddress", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success" && data?.isAvailable) {
          toast.success("ABHA address is available");
          this.setState({ isAvailable: true, suggestions: [] });
        } else {
          this.setState({
            isAvailable: false,
            suggestions: data.abhaDetails?.abhaAddressList || [],
          });
        }
      })
      .catch(() => toast.error("Error checking ABHA address availability"));
  };

  validateAbhaAddress = (input) => {
    const minLength = 6;
    const maxLength = 18;
    const regex = /^[a-zA-Z0-9._]+$/;

    if (
      input.length < minLength ||
      input.length > maxLength ||
      !regex.test(input)
    ) {
      return false;
    }

    if (/^[._]|[._]$/.test(input)) {
      return false; // can't start or end with . or _
    }

    const dotCount = (input.match(/\./g) || []).length;
    const underscoreCount = (input.match(/_/g) || []).length;

    if (dotCount > 1 || underscoreCount > 1) {
      return false;
    }

    return true;
  };

  // NEW: Debounced availability check (triggers after user stops typing for 1.5 seconds)
  checkAvailabilityDebounced = (abhaAddress) => {
    // Clear existing timeout
    if (this.checkAvailabilityTimeout) {
      clearTimeout(this.checkAvailabilityTimeout);
    }

    // Set new timeout
    this.checkAvailabilityTimeout = setTimeout(() => {
      this.checkAvailability(abhaAddress);
    }, 1500); // Check after 1.5 seconds of no typing
  };

  // NEW: Manual availability check
  checkAvailability = (abhaAddress) => {
    const { requestId } = this.state;
    
    if (!this.validateAbhaAddress(abhaAddress)) {
      return; // Don't check if format is invalid
    }

    this.setState({ isChecking: true });

    const formData = new FormData();
    formData.append("abhaAddress", abhaAddress);
    formData.append("requestId", requestId);

    fetch(configData.api_url + "C_Abhadetails/getSuggetionsByabhaAddress", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
              if (data.status === "success"){
                this.showToast(data.message, "success");
              }
        if (data.status === "success" && data?.isAvailable ) {
         
          this.setState({ 
            isAvailable: true, 
            suggestions: [],
            isChecking: false 
          });
        } else {
          this.setState({
            isAvailable: false,
            suggestions: data.abhaDetails?.abhaAddressList || [],
            isChecking: false
          });
        }
      })
      .catch(() => {
        this.setState({ isChecking: false });
        this.showToast("Error checking ABHA address availability", "error");
      });
  };

  // NEW: Manual check button click
  handleCheckAvailability = () => {
    const { abhaAddress } = this.state;
    if (abhaAddress && this.validateAbhaAddress(abhaAddress)) {
      this.checkAvailability(abhaAddress);
    } else {
      this.showToast("Please enter a valid ABHA address first", "warning");
    }
  };

  handleSuggestionClick = (suggestion) => {
    const isValid = this.validateAbhaAddress(suggestion);
    this.setState({
      abhaAddress: suggestion,
      isValid,
      isAvailable: null,
      suggestions: [],
      abhaDetails: {},
    });
    
    // Auto-check availability for suggested address
    if (isValid) {
      this.checkAvailabilityDebounced(suggestion);
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { abhaAddress } = this.state;
    
    // Validate before submission
    if (!this.validateAbhaAddress(abhaAddress)) {
      this.showToast("Please enter a valid ABHA address", "error");
      return;
    }

    const formData = new FormData();
    this.setState({ isSubmitting: true });

    formData.append("abhaAddress", abhaAddress);
    formData.append("requestId", this.state.requestId);

    fetch(configData.api_url + "C_Abhadetails/setnewabhaAddress", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        toast[data.status === "success" ? "success" : "error"](data.message);
        this.setState({ 
          isSubmitting: false,
          // Reset availability check state after successful creation
          isAvailable: data.status === "success" ? true : null,
          suggestions: data.status === "success" ? [] : this.state.suggestions
        });
      })
      .catch((error) => {
        toast.error("Error creating ABHA address");
        this.setState({ isSubmitting: false });
      });
  };

  handlenextClick = () => {
    const formData = new FormData();
    formData.append("requestId", this.state.requestId);
    fetch(configData.api_url + "C_Abhadetails/getAbhaProfile", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        sessionStorage.setItem("abhaAddress", this.state.abhaAddress);
        this.showToast(data.message);

        if (data.status === "success") {
          sessionStorage.setItem("abhaProfileStatus", "success");
          window.location.href = "/abhaprofile";
        }
      })
      .catch((error) => {
        this.showToast("Error retrieving ABHA profile", "error");
      });
  };

  handleAbhaChange = (e) => {
    const abhaAddress = e.target.value.trim();
    const isValid = this.validateAbhaAddress(abhaAddress);
    
    this.setState({ 
      abhaAddress, 
      isValid, 
      isAvailable: null, 
      suggestions: [],
      isChecking: false 
    });

    // Auto-check availability after user stops typing (debounced)
    if (isValid && abhaAddress.length >= 6) {
      this.checkAvailabilityDebounced(abhaAddress);
    }
  };

  render() {
    const { isValid, abhaAddress, suggestions, isSubmitting, isAvailable, isChecking } = this.state;
    
    return (
      <div>
        <div className="row justify-content-md-center text-center abhaAddressChange">
          <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>
            ABHA Address Update / Creation
          </h3>
          <div className="col-md-6">
            <div className="widget_BG widget_BG_grid mb-2">
              <Form.Group>
                <Form.Label>ABHA Address Creation</Form.Label>
                <div className="d-flex gap-2">
                  <Form.Control
                    type="text"
                    value={abhaAddress}
                    onChange={this.handleAbhaChange}
                    // REMOVED: onBlur event completely
                    onKeyDown={this.onKeyDown}
                    className={`form-control ${
                      abhaAddress ? (isValid ? "is-valid" : "is-invalid") : ""
                    }`}
                    disabled={isSubmitting}
                    placeholder="Enter ABHA address"
                  />
                  {/* NEW: Manual check button */}
                  <Button 
                    variant="outline-primary" 
                    onClick={this.handleCheckAvailability}
                    disabled={!isValid || !abhaAddress || isChecking}
                    className="rounded-0"
                  >
                    {isChecking ? "..." : "Check"}
                  </Button>
                </div>
                
                <Form>
                  <p>
                    Current ABHA Address:
                    <strong style={{ wordBreak: "break-word" }}>
                      {" "}{sessionStorage.abhaAddress}
                    </strong>
                  </p>
                  
                  {/* NEW: Availability status indicators */}
                  {isChecking && (
                    <div className="text-info mt-1" style={{ fontSize: "0.9rem", textAlign: "left" }}>
                      🔍 Checking availability...
                    </div>
                  )}
                  
                  {isAvailable === true && (
                    <div className="text-success mt-1" style={{ fontSize: "0.9rem", textAlign: "left" }}>
                      ✅ ABHA Address is available!
                    </div>
                  )}
               
                  {abhaAddress && !isValid && (
                    <div className="text-danger mt-1" style={{ fontSize: "0.9rem", textAlign: "left" }}>
                      ABHA Address Rules:
                      <ul className="m-0 ps-3">
                        <li>Length must be between 6 to 18 characters</li>
                        <li>Only letters, numbers, dots (.) and underscores (_) allowed</li>
                        <li>Cannot start or end with dot or underscore</li>
                        <li>At most 1 dot and 1 underscore allowed</li>
                      </ul>
                    </div>
                  )}
                </Form>

                <div className="mt-2">
                  <div className="d-flex flex-wrap mt-1">
                    {suggestions.length > 0 && (
                      <div className="mt-2">
                        <strong>Suggestions:</strong>
                        <div className="d-flex flex-wrap mt-1">
                          {suggestions.map((s, i) => (
                            <span
                              key={i}
                              className="badge bg-secondary me-2 mb-2"
                              onClick={() => this.handleSuggestionClick(s)}
                              style={{ cursor: "pointer" }}
                            >
                              {s}
                            </span>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </Form.Group>
              
              <Button 
                className="rounded-0 m-1" 
                onClick={this.handleSubmit}
                disabled={isSubmitting || !isValid || !abhaAddress}
              >
                {isSubmitting ? "Creating..." : "New ABHA Address"}
              </Button>
            </div>
          </div>
        </div>
        
        <div className="row widget_BG widget_BG_grid m-0 mt-2">
          <div className="col text-end">
            <Button className="rounded-0 m-1" onClick={this.handlenextClick}>
              Next
            </Button>
          </div>
        </div>
      </div>
    );
  }
}